export default "__VITE_ASSET__CFqMZqXy__"